export * as modalStyleConfigs from './style-configs';
export { Modal } from './modal';
